import { render, staticRenderFns } from "./AmountNumber.vue?vue&type=template&id=ced3ccd0&scoped=true&"
import script from "./AmountNumber.vue?vue&type=script&lang=js&"
export * from "./AmountNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced3ccd0",
  null
  
)

export default component.exports